import { Block, BlockKind, BlockTypes } from '../../types/blueprint'

import { BaseBlockConfig } from './_BaseBlockConfig'
import { ActionsCaptureBlockConfig } from './ActionsCaptureBlockConfig'
import { CheckAllCaptureBlockConfig } from './CheckAllCaptureBlockConfig'
import { CheckboxCaptureBlockConfig } from './CheckboxCaptureBlockConfig'
import { DateTimeCaptureBlockConfig } from './DateTimeCaptureBlockConfig'
import { DateTimeDisplayBlockConfig } from './DateTimeDisplayBlockConfig'
import { DividerDisplayBlockConfig } from './DividerDisplayBlockConfig'
import { FileCaptureBlockConfig } from './FileCaptureBlockConfig'
import { HeadingDisplayBlockConfig } from './HeadingDisplayBlockConfig'
import { ImageCaptureBlockConfig } from './ImageCaptureBlockConfig'
import { ImageDisplayBlockConfig } from './ImageDisplayBlockConfig'
import { ListDisplayBlockConfig } from './ListDisplayBlockConfig'
import { ProjectHoursBudgetCaptureBlockConfig } from './ProjectHoursBudgetCaptureBlockConfig'
import { ProjectLocationCaptureBlockConfig } from './ProjectLocationCaptureBlockConfig'
import { RadioCaptureBlockConfig } from './RadioCaptureBlockConfig'
import { RichTextCaptureBlockConfig } from './RichTextCaptureBlockConfig'
import { RichTextDisplayBlockConfig } from './RichTextDisplayBlockConfig'
import { SelectCaptureBlockConfig } from './SelectCaptureBlockConfig'
import { SignatureCaptureBlockConfig } from './SignatureCaptureBlockConfig'
import { SubcontractorSelectCaptureBlockConfig } from './SubcontractorSelectCaptureBlockConfig'
import { SubcontractorSummaryCaptureBlockConfig } from './SubcontractorSummaryCaptureBlockConfig'
import { SwmsGeneralInfoDisplayBlockConfig } from './SWMS/SwmsGeneralInfoDisplayBlockConfig'
import { SwmsHazardsDisplayBlockConfig } from './SWMS/SwmsHazardsDisplayBlockConfig'
import { SwmsHrcwDisplayBlockConfig } from './SWMS/SwmsHrcwDisplayBlockConfig'
import { SwmsPlantDisplayBlockConfig } from './SWMS/SwmsPlantDisplayBlockConfig'
import { SwmsPpeDisplayBlockConfig } from './SWMS/SwmsPpeDisplayBlockConfig'
import { TextCaptureBlockConfig } from './TextCaptureBlockConfig'
import { TextDisplayBlockConfig } from './TextDisplayBlockConfig'
import { TimeNotesCaptureBlockConfig } from './TimeNotesCaptureBlockConfig'
import { TodoCaptureBlockConfig } from './TodoCaptureBlockConfig'
import { ToggleCaptureBlockConfig } from './ToggleCaptureBlockConfig'
import { VideoDisplayBlockConfig } from './VideoDisplayBlockConfig'
import { WeatherCaptureBlockConfig } from './WeatherCaptureBlockConfig'
import { WorkerAttendanceCaptureBlockConfig } from './WorkerAttendanceCaptureBlockConfig'
import { WorkerQrCodeSignatureCaptureBlockConfig } from './WorkerQrCodeSignatureCaptureBlockConfig'

// this order dictates the display order when adding a block
const CAPTURE_BLOCK_CONFIGS = [
  RadioCaptureBlockConfig,
  CheckboxCaptureBlockConfig,
  SelectCaptureBlockConfig,
  FileCaptureBlockConfig,
  SignatureCaptureBlockConfig,
  DateTimeCaptureBlockConfig,
  TextCaptureBlockConfig,
  RichTextCaptureBlockConfig,
  ToggleCaptureBlockConfig,
  WeatherCaptureBlockConfig,
  TodoCaptureBlockConfig,
  TimeNotesCaptureBlockConfig,
  ImageCaptureBlockConfig,
  WorkerAttendanceCaptureBlockConfig,
  SubcontractorSummaryCaptureBlockConfig,
  ProjectHoursBudgetCaptureBlockConfig,
  ProjectLocationCaptureBlockConfig,
  SubcontractorSelectCaptureBlockConfig,
  ActionsCaptureBlockConfig,
  CheckAllCaptureBlockConfig,
  WorkerQrCodeSignatureCaptureBlockConfig,
]

// this order dictates the display order when adding a block
const DISPLAY_BLOCK_CONFIGS = [
  HeadingDisplayBlockConfig,
  TextDisplayBlockConfig,
  RichTextDisplayBlockConfig,
  ImageDisplayBlockConfig,
  DateTimeDisplayBlockConfig,
  ListDisplayBlockConfig,
  DividerDisplayBlockConfig,
  VideoDisplayBlockConfig,
  // SWMS SPECIFIC BLOCKS
  SwmsGeneralInfoDisplayBlockConfig,
  SwmsHazardsDisplayBlockConfig,
  SwmsHrcwDisplayBlockConfig,
  SwmsPlantDisplayBlockConfig,
  SwmsPpeDisplayBlockConfig,
]

const BLOCK_CONFIGS = [...CAPTURE_BLOCK_CONFIGS, ...DISPLAY_BLOCK_CONFIGS]

const BLOCK_TYPE_MAP = new Map<string, BaseBlockConfig<Block>>()

BLOCK_CONFIGS.forEach((blockConfig) => {
  BLOCK_TYPE_MAP.set(blockConfig.kind + ':' + blockConfig.type, blockConfig)
})

export const getBlockConfig = (kind: BlockKind, type: BlockTypes) => {
  return BLOCK_TYPE_MAP.get(kind + ':' + type)
}

export const getBlockConfigsByKind = (kind: BlockKind) => {
  return BLOCK_CONFIGS.filter((blockConfig) => blockConfig.kind === kind)
}
